import ContentCard from './ContentCard';

export default function ContentGrid({ items, loading }) {
  if (loading) return <div className="loading">Loading...</div>;
  if (!items.length) return <div className="empty">No content available</div>;

  return (
    <div className="content-grid">
      {items.map((item) => (
        <ContentCard key={item.id} content={item} />
      ))}
    </div>
  );
}
